import React from "react";
import { useApp } from "@/context/AppContext";
import {
  Table, TableHeader, TableBody, TableRow, TableHead, TableCell,
} from "@/components/ui/table";
import { TrendingUp, TrendingDown } from "lucide-react";

export const PriceTable = ({ prices }) => {
  const { t, formatPrice } = useApp();

  return (
    <div data-testid="price-table" className="overflow-hidden rounded-lg border border-border bg-white">
      <Table>
        <TableHeader>
          <TableRow className="bg-secondary/60 hover:bg-secondary/60">
            <TableHead className="text-start font-semibold text-neutral-700">{t("prices.region")}</TableHead>
            <TableHead className="text-start font-semibold text-neutral-700">{t("prices.quality")}</TableHead>
            <TableHead className="text-end font-semibold text-neutral-700">{t("prices.price")}</TableHead>
            <TableHead className="text-end font-semibold text-neutral-700">{t("prices.change")}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {prices.map((p) => {
            const up = p.change_pct >= 0;
            return (
              <TableRow key={p.id} data-testid={`price-row-${p.id}`}>
                <TableCell className="font-medium text-neutral-900">{p.region}</TableCell>
                <TableCell className="text-neutral-600">{t(`quality.${p.quality}`)}</TableCell>
                <TableCell className="text-end font-semibold text-primary">
                  {formatPrice(p.price_tnd)}<span className="text-xs font-normal text-neutral-400"> / {p.unit}</span>
                </TableCell>
                <TableCell className="text-end">
                  <span className={`inline-flex items-center justify-end gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${up ? "bg-primary/10 text-primary" : "bg-destructive/10 text-destructive"}`}>
                    {up ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                    {up ? "+" : ""}{p.change_pct}%
                  </span>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
